import { AiFillFile } from 'react-icons/ai'
import { MdOutlineArrowOutward } from 'react-icons/md'

import { Button } from '@/components/atoms/ui/button'

interface RegulationCardProps {
  title: string
  category: string
  link: string
}

export const RegulationCard = ({ title, category, link }: RegulationCardProps) => {
  return (
    <figure className="flex items-center gap-6 p-5 bg-white border border-blue-200 rounded-xl">
      <AiFillFile size={50} className="text-blue-200 size-[45px] md:size-[55px]" />
      <figcaption className="flex flex-col w-9/12 gap-3 md:gap-4 md:w-full md:flex-row md:items-center md:justify-between">
        <div className="space-y-2">
          <span className="px-2 py-1 text-xs font-semibold bg-blue-100 rounded text-primary-blue">{category}</span>
          <h3 className="text-sm font-bold md:text-lg">{title}</h3>
        </div>

        <Button variant="secondary" url={link || '#'} className="flex items-center w-[155px] gap-1 font-semibold shadow">
          <span>Lihat Peraturan</span>
          <MdOutlineArrowOutward size={16} />
        </Button>
      </figcaption>
    </figure>
  )
}
